export default "__VITE_ASSET__CO1JKX$Q__"